<template>
  <div id="AddFAQ">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/admin/faq'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select @change="changedData" @input="changedData" :items="categoryList" v-model="faq.category" label="Category" class="required pr-4 pl-4" required></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select @change="changedData" small-chips deletable-chips multiple @input="changedData" :rules="membershipRules" :items="membershipList" v-model="faq.membership" label="Membership" class="required pr-4 pl-4" required></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm12 md12">
          <v-text-field label="Question" v-model.trim="faq.title"
                        class="required pr-4 pl-4"
                        :rules="[rules.required]"
                        @input="changedData"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor" >
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <ejs-richtexteditor :height="ejsHeight" :rules="formRules.title" :content="content" :change="changedData" ref="rteObj" placeholder="Add description here.." :insertImageSettings="insertImageSettings" v-model="faq.description"></ejs-richtexteditor>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/admin/faq'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router  */
import { create } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';

import Vue from 'vue';
import { RichTextEditorPlugin, Toolbar, Image,  Link, HtmlEditor, QuickToolbar, NodeSelection } from '@syncfusion/ej2-vue-richtexteditor';

Vue.use(RichTextEditorPlugin);

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-vue-richtexteditor/styles/material.css';



// This lets admin to add new FAQ items
export default {
  name: 'AddFAQ',
  data: () => ({
    content: '',
    membershipList: [
      'Network',
      'Featured',
      'Preferred'
    ],
    membershipRules: [
      v => v.length > 0 || 'membership is required'
    ],
    editorOption: {
      placeholder: 'Add answer here..',
    },
    selectedData: false,
    faq: {
      title: '',
      description: '',
      category: 'General',
      membership: ['Featured']
    },
    categoryList: [
      'Account',
      'Album',
      'Blog',
      'General',
      'Letter',
      'Profile Layout',
      'Video',
    ],
    rules: {
      required: v => !!v.trim() || 'Field is required.',
    },
    error: '',
    ejsHeight: '400px', // editor data
    formRules: {
      title: [v => !!v || 'Description is required'],
    },
    insertImageSettings: {
      display: 'break',
      saveFormat: 'Base64' 
    }
  }),
  provide: {
    richtexteditor: [Toolbar, Image, Link, HtmlEditor, QuickToolbar]
  },
  computed: {
    ...mapGetters(['Faq']),
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to go back to the FAQ listing page
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/faq' });
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Used to save the new FAQ item
    async save () {
      if (!this.faq.description.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      } else {
        if (this.$refs.formAdd.validate()) { 
          this.selectedData = false;
          let { error, data, status } = await create('Faq', this.faq);
          if (error) {
            this.selectedData = true;
            console.log('error', error);
          } else {
            this.loading = false; 
            this.Faq.unshift(data);
            swal.fire({
              type: 'success',
              title: 'FAQ added successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$router.push({ path: '/admin/faq' });
              }
            });
          }
        }
      }
    }
  }
};
</script>

<style scoped>

  #AddFAQ >>> .e-richtexteditor .e-rte-toolbar {
    z-index: auto !important;
  }

  #AddFAQ >>> .e-linkheader, #AddFAQ >>> .imgUrl {
  display: none !important;
}

</style>


// WEBPACK FOOTER //
// src/pages/FAQ/add.vue